module.exports = __webpack_public_path__ + "static/img/Frame 1856.592ce1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper1/Frame 1856.png
// module id = 8FA3
// module chunks = 12